export default __webpack_public_path__ + "static/ADASC-white-5cd390d78395477e3fdd78461f69af20.svg";